<template>
  <ShopDropdown
    v-if="currentTournament.entry_fee.required"
    v-model="tournamentCurrency"
    :list="predefinedCurrency"
    :empty-text="$t('_web_shop_selectt', 'Select')"
    :label="$t('_web_tournaments_currency', 'Currency')"
    class="currency-picker"
  >
    <template slot="item" slot-scope="options">
      <div class="chevron-divider">
        <span v-if="options.item">
          {{ `${options.item}` }}
        </span>
      </div>
    </template>
  </ShopDropdown>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { translate } from '@/mixins/translate';
import ShopDropdown from '@/views/shop/components/ShopDropdown.vue';
export default {
  name: 'TournamentCurrencySetting',

  components: {
    ShopDropdown,
  },
  mixins: [translate('_web_tournament_settings')],
  data() {
    return {
      predefinedCurrency: ['SAR', 'USD'],
    };
  },
  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    paidTournament() {
      return this.currentTournament.entry_fee.required;
    },
    tournamentCurrency: {
      get() {
        return (
          this.$lodash.get(
            this.currentTournament,
            'entry_fee.currency',
            false
          ) || ''
        );
      },
      set(newVal) {
        this.updateCurrentTournament({
          currency: newVal,
          component: 'entry_fee',
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>
<style lang="scss">
.width-adjustment-paid {
  width: 300px;
}
.currency-picker {
  .float-dropbox {
    min-width: 160px;
    background-color: black !important;
    border: none;
  }
  .wrapper-control {
    .wrapper-control-label {
      label {
        font-family: 'Exo';
        padding-bottom: 15px;
        font-size: 0.875rem !important;
        font-weight: 600;
        line-height: 140% !important;
        color: #eff0f1 !important;
      }
    }
    button {
      height: 45px !important;
      background-color: black !important;
    }
  }
}
</style>
